import { useEffect, useState } from 'react';
import { ICatalogSectionRowBlock } from '@features/cms/typescript/index';
import styles from '@features/cms/components/pages/CatalogSectionBlocks/CatalogSectionBlocks.styles';
import CatalogSectionItemDefault from '@features/cms/components/pages/CatalogSectionBlocks/CatalogSectionItemDefault';
import CatalogSectionItemDescription from '@features/cms/components/pages/CatalogSectionBlocks/CatalogSectionItemDescription';
import CatalogSectionItemDescriptionBgImg from '@features/cms/components/pages/CatalogSectionBlocks/CatalogSectionItemDescriptionBgImg';
import CatalogSectionItemHeadingBgImg from '@features/cms/components/pages/CatalogSectionBlocks/CatalogSectionItemHeadingBgImg';
import CatalogSectionItemTextBgImg from '@features/cms/components/pages/CatalogSectionBlocks/CatalogSectionItemTextBgImg';
import theme from '@styles/theme';
import useResponsive from '@features/responsive/hooks/useResponsive';
import { TResponsiveType } from '@features/responsive/typescript';
import { ICatalogSectionItemBlock } from '@features/cms/typescript/index';
type PropsType = {
  row: ICatalogSectionRowBlock;
  isFirst: boolean;
};
const CatalogSectionRowBlock = ({
  row,
  isFirst
}: PropsType) => {
  const [currentBreakpoint, setCurrentBreakpoint] = useState<TResponsiveType>('desktop');
  const {
    currentBreakpoint: newCurrentBreakpoint
  } = useResponsive();
  const onResize = () => {
    setCurrentBreakpoint(newCurrentBreakpoint || 'desktop');
  };
  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  });
  const renderCatlogSectionItem = (item: ICatalogSectionRowBlock['items'][0], index: number) => {
    const key = `${row.layout}-${index}`;
    const getTextColor = (item: ICatalogSectionItemBlock): string => {
      if (item.textColor) return item.textColor;
      return theme.rawColors.darkGrey700;
    };
    const getTextHoverColor = (item: ICatalogSectionItemBlock): string => {
      if (item.textHoverColor) return item.textHoverColor;
      return theme.rawColors.darkGrey700;
    };
    const getBgColor = (item: ICatalogSectionItemBlock): string => {
      if (item.bgColor) return item.bgColor;
      return theme.rawColors.beige500;
    };
    const getBgHoverColor = (item: ICatalogSectionItemBlock): string => {
      if (item.bgHoverColor) return item.bgHoverColor;
      return theme.rawColors.beige500;
    };
    const getVideo = (item: ICatalogSectionItemBlock) => {
      if (currentBreakpoint === 'tablet' && item.video?.tablet) {
        return typeof item.video.tablet === 'string' ? `url(${item.video.tablet})` : `url(${item.video.tablet.path})`;
      }
      if (currentBreakpoint === 'mobile' && item.video?.mobile) {
        return typeof item.video.mobile === 'string' ? `url(${item.video.mobile})` : `url(${item.video.mobile.path})`;
      }
      if (item.video?.desktop) {
        return typeof item.video.desktop === 'string' ? `url(${item.video.desktop})` : `url(${item.video.desktop.path})`;
      }
      return 'none';
    };
    const getImage = (item: ICatalogSectionItemBlock) => {
      if (currentBreakpoint === 'tablet' && item.image?.tablet) {
        return typeof item.image.tablet === 'string' ? `url(${item.image.tablet})` : `url(${item.image.tablet.path})`;
      }
      if (currentBreakpoint === 'mobile' && item.image?.mobile) {
        return typeof item.image.mobile === 'string' ? `url(${item.image.mobile})` : `url(${item.image.mobile.path})`;
      }
      if (item.image?.desktop) {
        return typeof item.image.desktop === 'string' ? `url(${item.image.desktop})` : `url(${item.image.desktop.path})`;
      }
      return 'none';
    };
    const getHoverImage = (item: ICatalogSectionItemBlock) => {
      if (currentBreakpoint === 'tablet' && item.hoverImage?.tablet) {
        return typeof item.hoverImage.tablet === 'string' ? `url(${item.hoverImage.tablet})` : `url(${item.hoverImage.tablet.path})`;
      }
      if (currentBreakpoint === 'mobile' && item.hoverImage?.mobile) {
        return typeof item.hoverImage.mobile === 'string' ? `url(${item.hoverImage.mobile})` : `url(${item.hoverImage.mobile.path})`;
      }
      if (item.hoverImage?.desktop) {
        return typeof item.hoverImage.desktop === 'string' ? `url(${item.hoverImage.desktop})` : `url(${item.hoverImage.desktop.path})`;
      }
      return 'none';
    };
    switch (item.variant) {
      case 'description':
        return <CatalogSectionItemDescription key={key} item={item} layout={row.layout} isFirst={isFirst && !index} getTextColor={() => getTextColor(item)} getTextHoverColor={() => getTextHoverColor(item)} getBgColor={() => getBgColor(item)} getBgHoverColor={() => getBgHoverColor(item)} />;
      case 'descriptionBgImg':
        return <CatalogSectionItemDescriptionBgImg key={key} item={item} layout={row.layout} isFirst={isFirst && !index} getTextColor={() => getTextColor(item)} getTextHoverColor={() => getTextHoverColor(item)} getBgColor={() => getBgColor(item)} getBgHoverColor={() => getBgHoverColor(item)} getImage={() => getImage(item)} getVideo={() => getVideo(item)} />;
      case 'headingBgImg':
        return <CatalogSectionItemHeadingBgImg key={key} item={item} layout={row.layout} isFirst={isFirst && !index} getTextColor={() => getTextColor(item)} getTextHoverColor={() => getTextHoverColor(item) || ''} getHoverImage={() => getHoverImage(item)} getBgColor={() => getBgColor(item)} getBgHoverColor={() => getBgHoverColor(item)} />;
      case 'textBgImg':
        return <CatalogSectionItemTextBgImg key={key} item={item} layout={row.layout} isFirst={isFirst && !index} getTextColor={() => getTextColor(item)} getTextHoverColor={() => getTextHoverColor(item)} getHoverImage={() => getHoverImage(item)} getBgColor={() => getBgColor(item)} getBgHoverColor={() => getBgHoverColor(item)} />;
      default:
        return <CatalogSectionItemDefault key={key} item={item} layout={row.layout} isFirst={isFirst && !index} getTextColor={() => getTextColor(item)} getTextHoverColor={() => getTextHoverColor(item)} getBgColor={() => getBgColor(item)} getBgHoverColor={() => getBgHoverColor(item)} getHoverImage={() => getHoverImage(item)} getImage={() => getImage(item)} getVideo={() => getVideo(item)} />;
    }
  };
  return <div sx={styles.styledLayout(row.layout, true, '', undefined, undefined, undefined, undefined)}>
      {row.items.length > 0 && row.items.map((item, index) => renderCatlogSectionItem(item, index))}
    </div>;
};
export default CatalogSectionRowBlock;